import * as React from 'react';

import { DateValue } from '@internationalized/date';
import { Button, Col, DateRangePicker } from '@rematter/ui-web';
import { useAtom, useSetAtom } from 'jotai';

import {
  $columnDateRange,
  $offset,
} from '~/modules/finance/_state/financePayments.state';
import { useTranslations } from '~/modules/finance/i18n/useTranslations';

interface PaymentDateRangeColumnFilterProps {
  onClose?: () => void;
}

//
// ⚛️ ⚛️ ⚛️ PAYMENT DATE RANGE COLUMN FILTER ⚛️ ⚛️ ⚛️
//
export const PaymentDateRangeColumnFilter: React.FC<
  PaymentDateRangeColumnFilterProps
> = ({ onClose }) => {
  // Translations
  const t = useTranslations();

  // Atoms
  const [dateRange, setDateRange] = useAtom($columnDateRange);
  const setOffset = useSetAtom($offset);

  // Callbacks
  const handleDateChange = React.useCallback(
    (value: { start: DateValue; end: DateValue } | null) => {
      setDateRange(value);
      setOffset(0);
    },
    [setDateRange, setOffset],
  );

  const handleReset = React.useCallback(() => {
    setDateRange(null);
    setOffset(0);
  }, [setDateRange, setOffset]);

  return (
    <Col
      gap3
      yBetween
      className="@PaymentDateRangeColumnFilter h-35 min-w-75 p-3"
    >
      <DateRangePicker
        value={dateRange}
        onChange={handleDateChange}
        label={t.payments.list.dateFilter.label}
        aria-label={t.payments.list.dateFilter.label}
      />

      <div className="flex justify-end gap-2">
        <Button
          variant="outline"
          onPress={handleReset}
          color="neutral"
          isDisabled={!dateRange}
        >
          {t.payments.list.dateFilter.clear}
        </Button>
        <Button variant="solid" onPress={onClose}>
          {t.payments.list.dateFilter.done}
        </Button>
      </div>
    </Col>
  );
};
